import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { forEach as _forEach } from 'lodash';
import { Button, Col, Row } from 'react-bootstrap';
import Axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import FormInput from 'components/forms/FormInput';
import { addNotification } from 'actions/NotificationsActions';
import { leadMasterCopyUploaded } from 'actions/DataActions';
import EntityPropsUpdater from 'js/component/EntityPropsUpdater';
import { S3_LINKS } from 'js/constants';
import LoaderCC from '../LoaderCC';

class LeadOrderProof extends EntityPropsUpdater {
  constructor(props) {
    super(props);
    this.state = {
      printing: false,
      sendMasterCopyMail: false,
      selectedFiles: [],
      uploading: false,
      progress: 0,
      message: '',
      createdOrUploadedPDF: '',
      createdOrUploadedPDFX4: '', // secondary file: X4 pdf, when original was converted to flattened X3 pdf
      mailResponse: [],
    };
    this.fileUploadRef = React.createRef();
  }

  getPDF = (editionId, orderId) => {
    const {
      intl: { messages },
    } = this.props;
    this.setState({ printing: true });
    Axios.post('/api/ordermastercopy/renew/mastercopies/' + orderId + '.json', {})
      .then(({ data }) => {
        // can be a single object or an array of 2 or more objects
        const [uploadedS3Url, uploadedX4Url] = data;
        const { updateLeadMasterCopyUrl } = this.props;

        // update this Lead in Redux state: data.lead..
        updateLeadMasterCopyUrl(uploadedS3Url);

        const stateUpdate = { printing: false, createdOrUploadedPDF: uploadedS3Url };
        if (uploadedX4Url) {
          stateUpdate.createdOrUploadedPDFX4 = uploadedX4Url;
        }

        this.setState(stateUpdate, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.create_printData}</h1>
                  <p>{messages.created_new_printData}</p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="primary"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(error => {
        // handle error
        if (Axios.isCancel(error)) {
          console.log('POST request canceled', error);
        } else {
          console.log(error);
        }
      });
  };

  resendMasterCopies = orderId => {
    const { entity } = this.props;

    // optional override of target email(s)
    const emails = entity.getEmailOnPdfUpdate();

    this.setState({ sendMasterCopyMail: true });
    Axios.post('/api/ordermastercopy/resend/mastercopies/' + orderId + '.json', { emails })
      .then(response => {
        const {
          intl: { messages },
        } = this.props;

        this.setState({ sendMasterCopyMail: false, mailResponse: response.data[0] }, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.upload}</h1>
                  <p>{messages.uploaded_printData_successful}</p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="info"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(error => {
        // handle error
        if (Axios.isCancel(error)) {
          console.log('POST request canceled', error);
        } else {
          console.log(error);
        }
      });
  };

  selectFiles = (e, orderId) => {
    this.setState({ selectedFiles: e.target.files }, () => {
      this.uploadFiles(orderId);
    });
  };

  uploadFiles = orderId => {
    const {
      intl: { messages },
    } = this.props;
    const { selectedFiles } = this.state;
    this.setState({ uploading: true, progress: 0 });
    const formData = new FormData();
    _forEach(selectedFiles, (file, i) => {
      formData.append(`file${i}`, file);
    });

    Axios.post(`/api/ordermastercopy/upload/mastercopies/${orderId}.json?_method=put`, formData)
      .then(({ data }) => {
        const [uploadedS3Url] = data;
        const { updateLeadMasterCopyUrl } = this.props;

        // update this Lead in Redux state: data.lead..
        updateLeadMasterCopyUrl(uploadedS3Url);

        this.setState({ uploading: false, createdOrUploadedPDF: uploadedS3Url }, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.upload}</h1>
                  <p>{messages.uploaded_printData_successful}</p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="info"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(err => {
        this.setState({ message: 'Could not upload file!' });
        console.error(err);
      });
  }; // End uploadFiles

  onChangeEmails = (name, value) => {
    // very simple email address regexp
    const regex = /^[A-Z0-9+_.-]+@[A-Z0-9.-]+$/i;

    if (!regex.test(value.toString())) {
      // TODO: act on invalid email address
    }
    this.updateEntity(name, value);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      entity,
      entityLoaded,
    } = this.props;

    const {
      printing,
      sendMasterCopyMail,
      // progress,
      uploading,
      createdOrUploadedPDF,
      createdOrUploadedPDFX4,
    } = this.state;

    if (!entityLoaded) {
      return <LoaderCC />;
    }

    const wrapOutput = output => <div className="clearfix padding-25 sm-padding-10">{output}</div>;

    const output = [];
    const orders = entity.getOrders();
    if (!orders.length) {
      return wrapOutput(<p>{messages.no_printData}</p>);
    }

    const imageOutput = [];
    const order = orders[0];

    let itemDataCheck = null;
    let itemOrderable = null;
    let enableDataCheck = null;
    const orderItems = order.getItems();
    orderItems.forEach(item => {
      const code = item.getCode();
      // TODO: fix bad design. `enableDatacheck` value depends on the order of items in the order
      if (code === null) {
        itemOrderable = item;
        enableDataCheck = true;
      } else if (code === 'DATA_CHECK') {
        itemDataCheck = item;
        enableDataCheck = false; // show it only in lead if dataproof is not ordered
      } else if (code === 'PRINT_PRODUCTION') {
        itemOrderable = item;
        enableDataCheck = true;
      }
    });

    const edition = itemOrderable?.getEdition();
    if (!edition?.getId()) {
      return wrapOutput(<p>Edition not found</p>);
    }

    const editionId = edition.getId();
    const usedMedia = edition.getUsedMedia();
    if (usedMedia.length === 0) {
      imageOutput.push(
        <p key="no_images">
          <i className="far fa-images" /> {messages.no_images}
        </p>
      );
    } else {
      const s3 = S3_LINKS.MEDIA_IMGS_ORIGINAL;
      _forEach(edition.getUsedMedia(), (item, i) => {
        imageOutput.push(
          // falls download direkt add <a .... download>;
          <p key={item.key}>
            <i className="far fa-images" />
            <a target="_blank" rel="noopener noreferrer" href={s3 + item.key}>
              {item.originalname}
            </a>
          </p>
        );
      });
    }

    let buttonStyle = '';
    let pdfLink;
    let pdfLinkX4;
    let originalMasterCopy = '';

    if (createdOrUploadedPDF.length > 0) {
      pdfLink = createdOrUploadedPDF;
      if (createdOrUploadedPDFX4) {
        pdfLinkX4 = createdOrUploadedPDFX4;
      }
    } else {
      [pdfLink, pdfLinkX4] = orderItems[0].masterCopies;
    }

    const isAuthorized =
      order
        .getAuthorizationList()
        .find(({ type }) => type === 'manual_data_check')
        ?.getIsAuthorized() ?? false;

    if (edition.getMdate() !== orderItems[0].masterCopiesDate || pdfLink === '') {
      buttonStyle = 'danger';
    } else {
      buttonStyle = 'default';
    }

    // neuer wert aus backend, bei upload muss dieser gesetzt werden
    if (orderItems[0].isLocallyChanged === true) {
      originalMasterCopy = messages.not_the_original_printFile;
    }

    const MANUAL_DATA_CHECK_PIPELINE = '5f4c0cd929abcb326b11cf22'; // TODO pick dynamically from html
    const hasActions = !isAuthorized && entity.getPipeline().getId() === MANUAL_DATA_CHECK_PIPELINE;

    // send pdf by email confirm dialog
    const confirmButtonStyle = {
      margin: '20px auto 0',
      width: '40%',
      'flex-grow': 0,
      'flex-shrink': 0,
      'flex-basis': 'auto',
    };

    const options = {
      customUI: ({ onClose }) => (
        <div className="react-confirm-alert-body">
          <h1>{messages.are_you_sure}</h1>
          <p>{messages.send_doc_as_message}</p>
          {entity.getEmailOnPdfUpdate() && (
            <p>
              {messages.to}: {entity.getEmailOnPdfUpdate()}
            </p>
          )}
          <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
            <button style={confirmButtonStyle} bsStyle="primary" onClick={onClose} type="button">
              {messages.no}
            </button>
            <button
              style={confirmButtonStyle}
              bsStyle="primary"
              onClick={() => {
                this.resendMasterCopies(order.getId());
                onClose();
              }}
              type="button"
            >
              {messages.yes}
            </button>
          </div>
        </div>
      ),
    };

    output.push(
      <div className="panel panel-transparent" key="mainPanel">
        <Row>
          <Col md={12}>
            <h3>
              {messages.dataproof}
              {!enableDataCheck ? <></> : <span style={{ color: 'red' }}> ({messages.not_ordered}) </span>}
            </h3>
          </Col>
        </Row>
        <Row className="printDataRow">
          <Col md={6}>
            <div>
              <h4>{messages.customer_comment}</h4>
              {itemDataCheck && itemDataCheck.remarks ? (
                <div
                  style={{
                    marginTop: '-1ch',
                    backgroundColor: '#F0F0F0',
                    border: '1px solid #DFDFDF',
                    borderLeft: '5px solid #5BB2DA',
                    padding: '1ch',
                    borderRadius: '0px 3px 3px 0px',
                  }}
                >
                  <p style={{ fontWeight: 'bold' }}>{itemDataCheck.remarks}</p>
                </div>
              ) : (
                <p style={{ fontStyle: 'italic' }}>Keine vorhanden</p>
              )}
            </div>
            <div>
              <h4>{messages.printDataFiles}</h4>
              <p>
                <i className="fal fa-file-pdf" />{' '}
                {pdfLink ? (
                  <a href={pdfLink} target="_blank" rel="noopener noreferrer">
                    {pdfLink.split('/').pop()}
                  </a>
                ) : (
                  messages.not_available
                )}
              </p>
              {!!pdfLinkX4 && (
                <p>
                  <i className="fal fa-file-pdf" />{' '}
                  <a href={pdfLinkX4} target="_blank" rel="noopener noreferrer">
                    {pdfLinkX4.split('/').pop()} (PDF/X-4)
                  </a>
                </p>
              )}
              <h5 style={{ color: '#CD1719' }}>{originalMasterCopy}</h5>
              <div class="form-group">
                <h5>{messages.send_doc_as_message}</h5>
                <FormInput
                  label={messages.alternative_recepient}
                  name="emailOnPdfUpdate"
                  value={entity.getEmailOnPdfUpdate()}
                  infoText={messages.enter_email_address}
                  onChange={this.onChangeEmails}
                  style={{ marginTop: '10px' }}
                />
                <Button bsStyle="info" disabled={sendMasterCopyMail} onClick={() => confirmAlert(options)}>
                  {sendMasterCopyMail ? (
                    <i className="far fa-spin fa-spinner-third" />
                  ) : (
                    <i className="fal fa-envelope" />
                  )}{' '}
                  {messages.send}
                </Button>
              </div>
            </div>
            <div>
              <h4>{messages.image_files}</h4>
              <div>{imageOutput}</div>
            </div>
          </Col>
          <Col md={6}>
            <div>
              <div>
                <h4>{messages.actions_}</h4>
              </div>
              <div class="image-upload">
                <h5>{messages.upload_local_changes}</h5>
                <p>{messages.dataproof_master_copies_upload}</p>
                <Button
                  bsStyle="info"
                  onClick={() => {
                    if (uploading) return;
                    this.fileUploadRef.current.click();
                  }}
                >
                  <i className={uploading ? 'far fa-spin fa-spinner-third' : 'far fa-upload'} /> Upload
                </Button>
                <input
                  id="file-input"
                  ref={this.fileUploadRef}
                  type="file"
                  accept=".pdf"
                  multiple
                  onChange={e => {
                    this.selectFiles(e, order.getId());
                  }}
                />
              </div>
              {/* TODO FEHLER in Eventübergabe an Progressbar
            <div>
              {uploading && (
                <div className="progress">
                  <div
                    className="progress-bar progress-bar-info progress-bar-striped"
                    role="progressbar"
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: progress + "%" }}
                  >
                    {progress}%
                  </div>
                </div>
              )}
            </div>
            */}

              {!hasActions && !enableDataCheck ? (
                <></>
              ) : (
                <div>
                  <h5>{messages.edit_edition}</h5>
                  <p>{messages.dataproof_master_copies_recreate}</p>
                  <h6>{messages.hint}</h6>
                  <p>{messages.dataproof_hint_master_copies_upload}</p>
                  <Button bsStyle="warning" href={appIntl.urlPrefix + 'editor/' + editionId}>
                    <i className="fal fa-edit" /> {messages.edit}
                  </Button>
                  &nbsp;
                  <Button bsStyle={buttonStyle} onClick={() => this.getPDF(editionId, order.getId())}>
                    {printing ? <i className="far fa-spin fa-spinner-third" /> : null}
                    <i className="fal fa-file-pdf" /> {messages.create_printData}
                  </Button>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return wrapOutput(output);
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    updateLeadMasterCopyUrl: uploadedS3Url => {
      dispatch(leadMasterCopyUploaded(uploadedS3Url));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeadOrderProof)
);
